import { render, staticRenderFns } from "./internationality.vue?vue&type=template&id=3822148d&scoped=true&"
import script from "./internationality.vue?vue&type=script&lang=js&"
export * from "./internationality.vue?vue&type=script&lang=js&"
import style0 from "./internationality.vue?vue&type=style&index=0&id=3822148d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3822148d",
  null
  
)

export default component.exports